import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addAgencyLTA } from "common/services/contracts.service";
import LTAForm from "./LTAForm";
import { toast } from "react-toastify";

const AddLTA: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchContracts: () => void;
  isLTA?: boolean;
}> = ({ toggle, isModalOpen, fetchContracts, isLTA }) => {
  const [loading, setLoading] = useState<boolean>(false);
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      contractTitle: "",
      contractNo: "",
      contractor: {
        value: "",
        label: "",
      },

      contractRating: {
        value: "",
        label: "",
      },
      contractType: {
        value: "",
        label: "",
      },
      contractValue: "",
      startDate: "",
      endDate: "",
      isLTA: isLTA || false,
      regions: [],
      selectedFiles: [],
      additionalInformation: "",
      isLTAUsableByOtherAgencies: "",
    },
    validationSchema: Yup.object({
      contractTitle: Yup.string().required("Please enter contract title"),
      contractNo: Yup.string().required("Please enter contract number"),
      contractor: Yup.object().shape({
        value: Yup.number().required("Please select contractor"),
      }),

      contractRating: Yup.object().shape({
        value: Yup.number().nullable(),
      }),
      contractType: Yup.object().shape({
        value: Yup.number().required("Please select contract type"),
      }),
      contractValue: Yup.number().required("Please enter contract value"),
      startDate: Yup.string(),
      endDate: Yup.string(),
      regions: Yup.array().of(
        Yup.object().shape({
          label: Yup.string().required("Country is required"),
          value: Yup.string().required("Country is required"),
        })
      ),
      selectedFiles: Yup.array(),
      additionalInformation: Yup.string(),
      isLTAUsableByOtherAgencies: Yup.string(),
    }),
    onSubmit: async (values: any) => {
      const data = {
        contractTitle: values["contractTitle"],
        contractor: values["contractor"]["value"] || null,
        contractNo: values["contractNo"],
        contractRating: values["contractRating"]["value"] || null,
        contractType: values["contractType"]["value"] || null,
        contractValue: values["contractValue"],
        startDate:
          values["startDate"] &&
          values["startDate"]?.toLocaleDateString("en-CA"),
        endDate:
          values["endDate"] && values["endDate"]?.toLocaleDateString("en-CA"),
        isLTA: true,
        location: values["regions"].map((el: any) => el.value),
        additionalInformation: values["additionalInformation"],
        isLTAUsableByOtherAgencies:
          values["isLTAUsableByOtherAgencies"] === "Yes" ? true : false,
      };

      setLoading(true);
      try {
        const formData = new FormData();
        console.log("Selected Files", values.selectedFiles);
        values.selectedFiles.forEach((file: any) => {
          formData.append("files.ltaDocuments", file, file.name);
        });
        formData.append("data", JSON.stringify(data));

        await addAgencyLTA(formData);
        fetchContracts();
        validation.resetForm();
        toggle();
        toast.success("LTA Added Successfully", {});
      } catch (e: any) {
        toast.error("LTA Creation Failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add LTA
      </ModalHeader>

      <LTAForm
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
        setLoading={setLoading}
      />
    </Modal>
  );
};

export default AddLTA;
